import {
  Column,
  DataTable,
  DateCellComponent,
  DefaultTableFilterProps,
  DetailsIcon,
} from '@uni-space/uni-components';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSortCenterBags } from '../api';
import { WeightCheckBagDto } from '../model/weightCheck';
import WeightCheckBag from './WeightCheckBag';
import './WeightCheck.scss';

export default function WeightCheck() {
  const { t, i18n } = useTranslation();
  const [openedBag, setOpenedBag] = useState<{ id: number; number: string } | null>(null);

  const filters: DefaultTableFilterProps<WeightCheckBagDto>[] = useMemo(
    () => [
      {
        type: 'search',
        id: 'bagNumbers',
        name: 'Bag Number',
        label: t('weightCheck.bagSearch'),
        variant: 'primary',
      },
      {
        type: 'search',
        id: 'trackNumbers',
        name: 'Track Number',
        label: t('tableHeader.trackNumber'),
        variant: 'primary',
      },
    ],
    [t],
  );

  const columns: Column<WeightCheckBagDto>[] = useMemo(
    () => [
      {
        header: t('weightCheck.open'),
        accessor: 'id',
        textAlign: 'center',
        flex: 0.5,
        renderCell: (row) => (
          <DetailsIcon cursor="pointer" size="s" onClick={() => setOpenedBag({ id: row.id, number: row.number ?? '' })} />
        ),
      },
      {
        header: t('tableHeader.number'),
        accessor: 'number',
        textAlign: 'center',
        renderCell: (row) => (
          <span className="wc-link" onClick={() => setOpenedBag({ id: row.id, number: row.number ?? '' })}>
            {row.number ?? '—'}
          </span>
        ),
      },
      { header: t('tableHeader.parcelsCount'), accessor: 'parcelsCount', textAlign: 'center', flex: 0.5 },
      {
        header: t('tableHeader.actualWeightHeader'),
        accessor: 'actualWeight',
        textAlign: 'center',
        renderCell: (row) => `${row.actualWeight?.value} g`,
      },
      { header: t('bagCode'), accessor: 'bagCode', textAlign: 'center' },
      { header: t('tableHeader.regionZone'), accessor: 'regionZone', textAlign: 'center', flex: 0.7 },
      { header: t('tableHeader.userName'), accessor: 'userName', textAlign: 'center', flex: 1.5 },
      {
        header: t('tableHeader.createdAt'),
        accessor: 'createdAt',
        textAlign: 'center',
        renderCell: (row) => <DateCellComponent justify="center" date={row.createdAt} zone="local" />,
      },
      {
        header: t('tableHeader.closedAt'),
        accessor: 'closedAt',
        textAlign: 'center',
        renderCell: (row) => <DateCellComponent justify="center" date={row.closedAt} zone="local" />,
      },
    ],
    [t],
  );

  return (
    <>
      <DataTable
        columns={columns}
        filters={filters}
        height="calc(100vh - 180px)"
        onFetch={getSortCenterBags}
        lang={i18n.language}
      />
      <WeightCheckBag bag={openedBag} onClose={() => setOpenedBag(null)} />
    </>
  );
}
